const LABELS = {
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude'
};

export default LABELS;
